<template>
    <div>
        <p class="h2 text-uppercase">{{ headline }}</p>
        <div class="row">
            <div class="col-md-2 col-6">
                <a :href="url1" class="icon-container">
                    <img :src="img1" alt="Question mark icon">
                </a>
                <p>{{ txt1 }}</p>
            </div>
            <div class="col-md-2 col-6">
                <a :href="url2" class="icon-container">
                    <img :src="img2" alt="Alert triangle icon">
                </a>
                <p>{{ txt2 }}</p>
            </div>
            <div class="col-md-2 col-6">
                <a :href="url3" class="icon-container">
                    <img :src="img3" alt="Donwload icon">
                </a>
                <p>{{ txt3 }}</p>
            </div>
            <div class="col-md-2 col-6">
                <a :href="url4" class="icon-container">
                    <img :src="img4" alt="File text icon">
                </a>
                <p>{{ txt4 }}</p>
            </div>
            <div class="col-md-4">
                <a :href="url5" class="icon-container">
                    <img :src="img5" alt="Smartphone icon">
                    <p class="ff-proxima white ml-3">{{ imgtxt5 }}</p>
                </a>
                <p>{{ txt5 }}</p>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            headline: String,

            img1: String,
            img2: String,
            img3: String,
            img4: String,
            img5: String,

            txt1: String,
            txt2: String,
            txt3: String,
            txt4: String,
            txt5: String,

            name1: String,
            url1: String,
            imageurl1: String,
            imagealttext1: String,
            imagename1: String,

            name2: String,
            url2: String,
            imageurl2: String,
            imagealttext2: String,
            imagename2: String,

            name3: String,
            url3: String,
            imageurl3: String,
            imagealttext3: String,
            imagename3: String,

            name4: String,
            url4: String,
            imageurl4: String,
            imagealttext4: String,
            imagename4: String,

            name5: String,
            url5: String,
            imageurl5: String,
            imagealttext5: String,
            imagename5: String,

            imgtxt5: String,
        }
    }
</script>
